import http from "@/services/http";

interface UserConsent {
  consent_name: string;
  category_id: string;
  consent_id: string;
  status: boolean;
}

interface UserConsentsUser {
  user_id: string;
  email: string;
  user_consents: UserConsent[];
}

interface UserConsentsResponse {
  users: UserConsentsUser[];
}

export async function getEmailCommunicationOptIn(
  email: string
): Promise<boolean> {
  if (!window.env.API_PROFILE || !email) {
    return false;
  }
  const response = await http().post<UserConsentsResponse>(
    `${window.env.API_PROFILE}/user-consents`,
    { emails: [email] }
  );
  const user = response.data?.users?.[0];
  if (!user?.user_consents) {
    return false;
  }
  const consent = user.user_consents.find(
    (c) => c.consent_name === "email_notification_opt_in"
  );
  return consent?.status === true;
}

export async function setEmailCommunicationOptIn(email: string): Promise<void> {
  if (!window.env.API_PROFILE || !email) {
    return;
  }
  await http().post(`${window.env.API_PROFILE}/enrollGenAI`, {
    email_address: email,
    email_notification_opt_in: true,
  });
}
